import { Box, Paper } from "@mui/material"
import { createFileRoute, useNavigate } from "@tanstack/react-router"
import { useCallback, useState } from "react"

import { PageHeader } from "@/components/PageHeader/PageHeader"
import { type Company } from "@/graphql/codegen/graphql"
import { CompaniesActions } from "@/screens/Companies/components/CompaniesActions"
import { CompaniesSearch } from "@/screens/Companies/components/CompaniesSearch"
import { FilterDrawer } from "@/screens/Companies/components/filters/FilterDrawer"
import { TableContainer } from "@/screens/Companies/components/tables/TableContainer"
import CreateNewCompanyModal from "@/screens/Companies/create/components/CreateNewCompanyModal"
import { SearchParamsSchema } from "@/screens/Companies/types/searchParams"

const CompanyComponent = () => {
  const navigate = useNavigate()
  const [isVendorModalOpen, setVendorModalOpen] = useState(false)
  const [isFilterDrawerOpen, setFilterDrawerOpen] = useState(false)

  const handleCreateCompanySuccess = useCallback(
    ({ companyId }: Company) => {
      void navigate({ from: "/app/companies", to: `${companyId}/edit` })
    },
    [navigate]
  )

  const toggleFilterDrawer = useCallback(() => setFilterDrawerOpen((prev) => !prev), [])

  return (
    <>
      {/* Filter Drawer */}
      <FilterDrawer showFilterDrawer={isFilterDrawerOpen} toggleDrawer={toggleFilterDrawer} />

      {/* Main Content */}
      <Paper elevation={0} className='flex min-h-0 grow flex-col overflow-hidden bg-white'>
        <PageHeader title='Companies'>
          <CompaniesActions />
        </PageHeader>

        {/* Search and Actions */}
        <CompaniesSearch onShowModal={() => setVendorModalOpen(true)} onShowFilter={toggleFilterDrawer} />

        {/* Table Section */}
        <Box className='flex flex-1 flex-col overflow-y-auto'>
          <TableContainer />
        </Box>
      </Paper>

      {/* New Company Modal */}
      <CreateNewCompanyModal
        isOpen={isVendorModalOpen}
        onClose={() => setVendorModalOpen(false)}
        onSuccess={handleCreateCompanySuccess}
      />
    </>
  )
}

// Route definition with search param validation
export const Route = createFileRoute("/app/companies/")({
  validateSearch: SearchParamsSchema,
  component: CompanyComponent,
})
